import { Grid, lighten, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { UsersIcon } from "../../../../assets/icons";

const MyTeamMembersLink = () => {
  const tRP = "components.widgets.my_team_configuration.links.team_members";
  const { t } = useTranslation();

  const theme = useTheme();

  return (
    <>
      <Grid
        style={{
          boxShadow: theme.shadows[2],
          borderRadius: "5px",
          backgroundColor: lighten(theme.palette.success.main, 0.9),
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "25px 15px",
          gap: "20px",
          color: theme.palette.success.main,
          textAlign: "center",
          height: "100%",
        }}
      >
        <Typography>{`${t(`${tRP}`)}`}</Typography>
        <UsersIcon />
      </Grid>
    </>
  );
};

export default MyTeamMembersLink;
